import { PermissionsPermissionTypeModel as Model } from './Model'


export const MODULE_NAME = 'permissions.permission-types'

export const PERMISSIONS_PERMISSION_TYPES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PERMISSIONS_PERMISSION_TYPES_ROUTES.LAYOUT,
  route: { name: PERMISSIONS_PERMISSION_TYPES_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-call-merge',
} as const
